import script from "./PolicyVersionTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./PolicyVersionTabs.vue?vue&type=script&setup=true&lang=js"

import "./PolicyVersionTabs.vue?vue&type=style&index=0&id=5e7f63ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e7f63ee"]])

export default __exports__